import snoonuLogoPath from '../assets/snoonu/assets/official/snoonu-logo.svg';
import snoonuIconPath from '../assets/snoonu/assets/official/snoonu-icon.svg';
import birdWavingPath from '../assets/snoonu/assets/mockup/bird-waving.png';
import birdHeadPath from '../assets/snoonu/assets/mockup/bird-head.png';
import './Snoonu.module.css';

/**
 * Snoonu-branded interview theme.
 * Colors/fonts verified against snoonu.com (2026-10-01); survey layout
 * values are mockup specifications. See src/assets/snoonu/START-HERE.txt.
 */
export const snoonuTheme = {
  key: 'snoonu',
  matches: (haystack) => haystack.includes('snoonu'),
  cssVars: {
    '--as-blue': '#000000',
    '--as-cream': '#FFFFFF',
    '--as-cream-deep': '#F5F5F5',
    '--as-purple': '#D90217',
    '--as-green': '#D90217',
    '--as-grey': '#707070',
    '--as-light': '#CBCBCB',
    '--as-pink': '#FFF1F3',
    '--radius': '28px',
    '--font-primary': 'Inter, Arial, sans-serif',
    // Mockup survey styling
    '--question-border': '#FFC4CE',
    '--question-border-width': '1px',
    '--choice-border': '#9696A0',
    '--choice-border-width': '1.5px',
    '--choice-text': '#000000',
    '--selected-fill': '#FFF1F3',
    '--selected-text': '#000000',
    '--selected-border': '#D90217',
    '--progress-track': '#F8DFE5',
    '--progress-fill': '#D90217',
    '--btn-bg': '#D90217',
    '--btn-border': '#D90217',
    '--btn-text': '#FFFFFF',
    '--btn-pinkish-bg': '#D90217',
    '--btn-pinkish-border': '#D90217',
    '--btn-pinkish-text': '#FFFFFF',
    '--text-border': '#9696A0',
    '--text-border-width': '1.5px',
  },
  logo: snoonuLogoPath,
  icon: snoonuIconPath,
  headerTagline: 'The Conversation Experience',
  // Reuse the same bird-head avatar for all three stops; active is 100%
  // opacity, inactive 25%. Labels are removed per the mockup spec.
  tracker: {
    avatar: birdHeadPath,
    showLabels: false,
  },
  bot: birdWavingPath,
  footer: 'Powered by August Says Inc',
};
